module.exports = __webpack_public_path__ + "static/media/proceso_post_venta.bbea82b0.png";